import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import { UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import {AskInput} from "./askInput";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

@Component({
    selector: 'app-ask-input',
    templateUrl: './ask-input.component.html',
    styleUrls: ['./ask-input.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, ActiveFormDirective, MatSlideToggle, CMSComponent, NextSelectorComponent]
})
export class AskInputComponent extends NodeBuilder implements OnInit {

    askInputForm: UntypedFormGroup;

    constructor() {
        super("askInput");
    }

    ngOnInit(): void {
    }

    set buildForm(stepData: any) {
        this.askInputForm = AskInput.toForm(stepData, this.canEdit);
        if (this.askInputForm.get('next').value === newStepValue) {
            this.askInputForm.get('next').setValue('step' + this.getNextStep());
        }
    }

    get getStepData(): {} {
        const nodeData: AskInput = new AskInput();
        nodeData.setNodeData(this.askInputForm.getRawValue())
        return nodeData.nodeData;
    }

    get isNodeValid(): boolean {
        this.askInputForm.markAllAsTouched();
        return this.askInputForm.valid;
    }
}
